// Reason codes offered at delivery close and when a tally is confirmed against the
// expectation (chapter 4 §4.5, D4-2): the site's configured lists (SiteConfig.reasons),
// with "other" (free text) always last.

import type { SiteConfig } from "@trail/core";
import { t } from "../i18n.js";

export type ReasonCode = string;

export function reasonsForShort(cfg: SiteConfig | null): { value: ReasonCode; label: string }[] {
  return [...(cfg?.reasons.short ?? []).map((r) => ({ value: r.code, label: r.label })), { value: "other", label: t("close.other") }];
}

export function reasonsForOverride(cfg: SiteConfig | null): { value: ReasonCode; label: string }[] {
  return [...(cfg?.reasons.override ?? []).map((r) => ({ value: r.code, label: r.label })), { value: "other", label: t("close.other") }];
}

export function reasonsForExtra(cfg: SiteConfig | null): { value: ReasonCode; label: string }[] {
  return [...(cfg?.reasons.extra ?? []).map((r) => ({ value: r.code, label: r.label })), { value: "other", label: t("close.other") }];
}
